module.exports = __webpack_public_path__ + "img/undraw_online_shopping_ga73.9bf91f40.svg";